/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrebidResult {
  Pending = 'pending',
  Outbid = 'outbid',
  Won = 'won',
  CreditExhausted = 'credit_exhausted',
  PrebidGroupFulfilled = 'prebid_group_fulfilled'
}
